import { faker } from '@faker-js/faker'
import { v4 as uuidv4 } from 'uuid'
import StaticData from '../../@core/@shared/domain/entities/StaticData'
import { InterestVariable } from './DashboardAgility.types'

const buildResiduos = (count: number) =>
	Array.from({ length: count }, () => ({
		plantio: `T00${faker.number.int({ min: 1, max: 3 })}`,
		parcela: `IPC_${faker.number.int({ min: 100000, max: 9999999 })}`,
		valor_real: faker.number.float({ min: 25, max: 65, fractionDigits: 2 }),
		valor_estimado: faker.number.float({ min: 25, max: 65, fractionDigits: 4 }),
		residuo: faker.number.float({ min: -6, max: 6, fractionDigits: 4 }),
	}))

const buildVariavelCalculada = (
	variavel: InterestVariable,
	identificadorCamadaRaster: string,
	idEstratoInventarioFlorestal: string,
) => ({
	id: uuidv4(),
	id_estrato_inventario_florestal: idEstratoInventarioFlorestal,
	area: faker.number.float({ min: 50, max: 200, fractionDigits: 2 }),
	variavel_de_interesse: variavel,
	modelo_ajustado_latex: `$$AB (m^2/ha) = ${faker.number.float({ min: -50, max: 50, fractionDigits: 4 })} + ${faker.number.float({ min: 0, max: 1, fractionDigits: 4 })} \\cdot \\mathrm{hmax}$$`,
	coeficientes_modelo_ajustado: [
		faker.number.float({ min: -50, max: 50, fractionDigits: 8 }),
		faker.number.float({ min: 0, max: 1, fractionDigits: 8 }),
	],
	coeficiente_de_determinacao: faker.number.float({ min: 0.2, max: 0.99, fractionDigits: 4 }),
	raiz_erro_quadratico_medio: faker.number.float({ min: 1, max: 5, fractionDigits: 4 }),
	erro_absoluto_medio: faker.number.float({ min: 1, max: 4, fractionDigits: 4 }),
	erro_absoluto_medio_percentual: faker.number.float({ min: 1, max: 10, fractionDigits: 4 }),
	media_estimada: faker.number.float({ min: 30, max: 60, fractionDigits: 4 }),
	limite_inferior_intervalo_confianca: faker.number.float({ min: 25, max: 55, fractionDigits: 4 }),
	limite_superior_intervalo_confianca: faker.number.float({ min: 35, max: 65, fractionDigits: 4 }),
	erro_amostragem: faker.number.float({ min: 0.3, max: 2, fractionDigits: 4 }),
	erro_amostragem_percentual: faker.number.float({ min: 1, max: 5, fractionDigits: 4 }),
	numero_parcelas_necessarias: faker.number.int({ min: 30, max: 120 }),
	numero_parcelas_utilizadas: faker.number.int({ min: 20, max: 60 }),
	erro_amostragem_percentual_inventario_tradicional: faker.number.float({
		min: 1,
		max: 5,
		fractionDigits: 4,
	}),
	numero_parcelas_necessarias_inventario_tradicional: faker.number.int({ min: 50, max: 150 }),
	ganho_parcelas: faker.number.int({ min: 10, max: 80 }),
	residuos: buildResiduos(10),
	momento_geracao: faker.date.recent().toISOString(),
})

export class StaticDashboardAgilityData extends StaticData {
	static item: any = null

	static init() {
		const idEstratoInventarioFlorestal = uuidv4()
		const nomeRasterProcessado = `estrato_inventario_florestal_${idEstratoInventarioFlorestal}_${faker.number.int({ min: 1_000_000_000, max: 9_999_999_999 })}.tiff`

		this.item = {
			id_customer: uuidv4(),
			identificador_raster: nomeRasterProcessado,
			bandas: {
				[InterestVariable.VOLUME_TOTAL_COM_CASCA]: 'inpa_md_vtcc',
				[InterestVariable.VOLUME_TOTAL_SEM_CASCA]: 'inpa_md_vtsc',
			},
			variaveis_nao_calculadas: [],
			variaveis_calculadas: [
				buildVariavelCalculada(
					InterestVariable.VOLUME_TOTAL_COM_CASCA,
					'inpa_md_vtcc',
					idEstratoInventarioFlorestal,
				),
				buildVariavelCalculada(
					InterestVariable.VOLUME_TOTAL_SEM_CASCA,
					'inpa_md_vtsc',
					idEstratoInventarioFlorestal,
				),
			],
		}
	}

	static reset() {
		this.item = null
	}
}
